import React, { useState } from "react";
import Header from "../../Header";
import PropTypes from "prop-types";
import { Tabs, Tab, makeStyles, Box, Typography } from "@material-ui/core";
import DownloadTracking from "./DownloadTracking";
import "./CampusAmbassador.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: "80vh",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const CampusAmbassador = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Header type="mainHeader" headerText="Campus Ambassador Home" />
      <div className={classes.root}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Campus Ambassador Home"
          className={classes.tabs}
        >
          <Tab label="Download Tracking" {...a11yProps(0)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <DownloadTracking />
        </TabPanel>
      </div>
    </>
  );
};

export default CampusAmbassador;
